import { Injectable } from "@angular/core";
import { FormDataService } from "../data/form-data.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class StepOneGuardService {
  constructor(private formData: FormDataService, public router: Router) {}

  canActivate(): boolean {
    let course = localStorage.getItem("course_selected");
    let location = localStorage.getItem("location_selected");
    if (!location) {
      this.router.navigate(["/locations"], { queryParamsHandling: "merge" });
      return false;
    }
    if (!course) {
      this.router.navigate(["/type"], { queryParamsHandling: "merge" });
      return false;
    }
    return true;
  }
}
